import { FormValues } from "@utils/getFormValue";
import {
  ActionMTSaveSearch,
  ActionSetCurrentFilters,
  ActionSetMTFilters,
  ActionSetSpeedBage,
  ActionTypesFilters,
  IHashHamesPayload,
} from "./actionTypes";
import { MTFilters } from "./reducer";

export function setMTFilters(filters: MTFilters): ActionSetMTFilters {
  return {
    type: ActionTypesFilters.SET_MINER_TABLE_FILTERS,
    payload: filters,
  };
}

export function saveMTSearch(s: string[]): ActionMTSaveSearch {
  return {
    type: ActionTypesFilters.SET_MINER_TABLE_SEARCH,
    payload: s,
  };
}

export function clearMTFilters() {
  return {
    type: ActionTypesFilters.CLEAR_MINER_TABLE_FILTERS,
  };
}

export function setCurrentFilter(
  action: keyof typeof ActionTypesFilters,
  payload?: ActionSetCurrentFilters["payload"]
): ActionSetCurrentFilters {
  return {
    type: ActionTypesFilters[action],
    payload,
  };
}

export function setFilterBages(payload: IHashHamesPayload): ActionSetSpeedBage {
  return {
    type: ActionTypesFilters.SET_BAGES_FILTER,
    payload,
  };
}
